export default __webpack_public_path__ + "static/media/soy.a7640fa1.svg";